module.exports = __webpack_public_path__ + "img/play-store.f43f3815.svg";